// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 191 ? "city-data" : chunkId) + "." + {"191":"22f1425e","238":"bf664b46"}[chunkId] + ".chunk.js";
};